import sentry from '@services/sentry';
import { fetchAuthSession } from 'aws-amplify/auth';
import { ENV } from '../environment';
import session from './session';

function logError(errorObject: Error, extra: Record<string, unknown> = {}) {
  if (ENV === 'development') {
    // eslint-disable-next-line no-console
    console.error('🐛', errorObject, extra);
  } else {
    sentry.captureException(errorObject, extra);
  }
}

function identify({ email, id }: { email: string; id: string }) {
  sentry.setUser({ email, id });
}

async function start() {
  try {
    if (!session.get()) return;
    const amplifySession = await fetchAuthSession();
    const user = amplifySession.tokens?.idToken?.payload;
    if (user?.sub && user?.email) {
      identify({
        email: (user?.email || null) as string | null,
        id: user.sub as string,
      });
    }
  } catch (err: any) {
    // noop
  }
}

let hasInitialized = false;
export default (() => {
  if (!hasInitialized) {
    hasInitialized = true;
  }
  return {
    identify,
    logError,
    start,
  };
})();
